import gql from "graphql-tag";

export const MY_LEAVE_DELETE_LEAVE_TYPE_FILTER = gql`
  mutation removeLeaveTypeFilter($code: String!) {
    removeLeaveTypeFilter(code: $code)
  }
`;
